import Exception from './Exception';
/**
 * Custom Error class of type Exception.
 */
class ReaderException extends Exception {
}
ReaderException.kind = 'ReaderException';
export default ReaderException;
